/* generated from backend OpenAPI -- do not edit */
import type { JSONSchema } from 'zod/v4/core';
export const schema = {
  "anyOf": [
    {
      "oneOf": [
        {
          "type": "object",
          "properties": {
            "eventId": {
              "type": "string",
              "minLength": 1
            },
            "eventType": {
              "type": "string",
              "enum": [
                "communications.message.created"
              ]
            },
            "tenantId": {
              "type": "string",
              "minLength": 1
            },
            "funnelId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "funnelConversationId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "messagingConversationId": {
              "type": "string",
              "minLength": 1
            },
            "resourceId": {
              "type": "string",
              "minLength": 1
            },
            "occurredAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
            },
            "resourceType": {
              "type": "string",
              "enum": [
                "Message"
              ]
            },
            "action": {
              "type": "string",
              "enum": [
                "created"
              ]
            },
            "resource": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "string"
                },
                "tenantId": {
                  "type": "string"
                },
                "conversationId": {
                  "type": "string"
                },
                "funnelConversationId": {
                  "type": "integer",
                  "exclusiveMinimum": true,
                  "maximum": 9007199254740991
                },
                "sessionId": {
                  "type": "number"
                },
                "providerId": {
                  "type": "string"
                },
                "contactId": {
                  "type": "number"
                },
                "userId": {
                  "type": "string"
                },
                "content": {
                  "type": "string"
                },
                "status": {
                  "type": "string",
                  "enum": [
                    "pending",
                    "sent",
                    "failed",
                    "delivered",
                    "read",
                    "deleted",
                    "warning"
                  ]
                },
                "direction": {
                  "type": "string",
                  "enum": [
                    "inbound",
                    "outbound"
                  ]
                },
                "channel": {
                  "type": "string",
                  "enum": [
                    "whatsapp",
                    "email",
                    "sms"
                  ]
                },
                "sender": {
                  "type": "object",
                  "properties": {
                    "providerId": {
                      "type": "string"
                    },
                    "address": {
                      "type": "string"
                    },
                    "role": {
                      "type": "string",
                      "enum": [
                        "user",
                        "contact",
                        "system"
                      ]
                    },
                    "displayName": {
                      "type": "string"
                    },
                    "metadata": {
                      "type": "object",
                      "additionalProperties": {}
                    }
                  },
                  "required": [
                    "providerId",
                    "address",
                    "role"
                  ]
                },
                "recipient": {
                  "type": "object",
                  "properties": {
                    "providerId": {
                      "type": "string"
                    },
                    "address": {
                      "type": "string"
                    },
                    "role": {
                      "type": "string",
                      "enum": [
                        "user",
                        "contact",
                        "system"
                      ]
                    },
                    "displayName": {
                      "type": "string"
                    },
                    "metadata": {
                      "type": "object",
                      "additionalProperties": {}
                    }
                  },
                  "required": [
                    "providerId",
                    "address",
                    "role"
                  ]
                },
                "attachments": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "string"
                      },
                      "type": {
                        "type": "string",
                        "enum": [
                          "image",
                          "video",
                          "audio",
                          "file"
                        ]
                      },
                      "url": {
                        "type": "string"
                      },
                      "unsignedUrl": {
                        "type": "string"
                      },
                      "metadata": {
                        "type": "object",
                        "additionalProperties": {}
                      },
                      "mediaProcessing": {
                        "type": "object",
                        "properties": {
                          "textRepresentation": {
                            "type": "object",
                            "properties": {
                              "status": {
                                "type": "string",
                                "enum": [
                                  "pending",
                                  "processing",
                                  "completed",
                                  "failed"
                                ]
                              },
                              "content": {
                                "type": "string"
                              },
                              "processedAt": {
                                "type": "string"
                              },
                              "errorMessage": {
                                "type": "string"
                              }
                            },
                            "required": [
                              "status"
                            ]
                          },
                          "summary": {
                            "type": "object",
                            "properties": {
                              "status": {
                                "type": "string",
                                "enum": [
                                  "pending",
                                  "processing",
                                  "completed",
                                  "failed"
                                ]
                              },
                              "content": {
                                "type": "string"
                              },
                              "processedAt": {
                                "type": "string"
                              },
                              "errorMessage": {
                                "type": "string"
                              }
                            },
                            "required": [
                              "status"
                            ]
                          }
                        }
                      },
                      "isCacheable": {
                        "type": "boolean"
                      }
                    },
                    "required": [
                      "id",
                      "type",
                      "url"
                    ]
                  }
                },
                "createdAt": {
                  "type": "string"
                },
                "updatedAt": {
                  "type": "string"
                },
                "metadata": {
                  "type": "object",
                  "additionalProperties": {}
                },
                "errors": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "code": {
                        "type": "number"
                      },
                      "title": {
                        "type": "string"
                      },
                      "message": {
                        "type": "string"
                      },
                      "href": {
                        "type": "string"
                      },
                      "provider": {
                        "type": "string"
                      }
                    },
                    "required": [
                      "title"
                    ]
                  }
                },
                "customFields": {
                  "type": "object",
                  "additionalProperties": {}
                },
                "mediaProcessing": {
                  "type": "object",
                  "properties": {
                    "textRepresentation": {
                      "type": "object",
                      "properties": {
                        "status": {
                          "type": "string",
                          "enum": [
                            "pending",
                            "processing",
                            "completed",
                            "failed"
                          ]
                        },
                        "content": {
                          "type": "string"
                        },
                        "processedAt": {
                          "type": "string"
                        },
                        "errorMessage": {
                          "type": "string"
                        }
                      },
                      "required": [
                        "status"
                      ]
                    },
                    "summary": {
                      "type": "object",
                      "properties": {
                        "status": {
                          "type": "string",
                          "enum": [
                            "pending",
                            "processing",
                            "completed",
                            "failed"
                          ]
                        },
                        "content": {
                          "type": "string"
                        },
                        "processedAt": {
                          "type": "string"
                        },
                        "errorMessage": {
                          "type": "string"
                        }
                      },
                      "required": [
                        "status"
                      ]
                    }
                  }
                }
              },
              "required": [
                "id",
                "tenantId",
                "conversationId",
                "funnelConversationId",
                "providerId",
                "content",
                "status",
                "direction",
                "channel",
                "sender",
                "createdAt",
                "updatedAt"
              ]
            }
          },
          "required": [
            "eventId",
            "eventType",
            "tenantId",
            "funnelConversationId",
            "resourceId",
            "occurredAt",
            "resourceType",
            "action",
            "resource"
          ]
        },
        {
          "type": "object",
          "properties": {
            "eventId": {
              "type": "string",
              "minLength": 1
            },
            "eventType": {
              "type": "string",
              "enum": [
                "communications.message.updated"
              ]
            },
            "tenantId": {
              "type": "string",
              "minLength": 1
            },
            "funnelId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "funnelConversationId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "messagingConversationId": {
              "type": "string",
              "minLength": 1
            },
            "resourceId": {
              "type": "string",
              "minLength": 1
            },
            "occurredAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
            },
            "resourceType": {
              "type": "string",
              "enum": [
                "Message"
              ]
            },
            "action": {
              "type": "string",
              "enum": [
                "updated"
              ]
            },
            "resource": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "string"
                },
                "tenantId": {
                  "type": "string"
                },
                "conversationId": {
                  "type": "string"
                },
                "funnelConversationId": {
                  "type": "integer",
                  "exclusiveMinimum": true,
                  "maximum": 9007199254740991
                },
                "sessionId": {
                  "type": "number"
                },
                "providerId": {
                  "type": "string"
                },
                "contactId": {
                  "type": "number"
                },
                "userId": {
                  "type": "string"
                },
                "content": {
                  "type": "string"
                },
                "status": {
                  "type": "string",
                  "enum": [
                    "pending",
                    "sent",
                    "failed",
                    "delivered",
                    "read",
                    "deleted",
                    "warning"
                  ]
                },
                "direction": {
                  "type": "string",
                  "enum": [
                    "inbound",
                    "outbound"
                  ]
                },
                "channel": {
                  "type": "string",
                  "enum": [
                    "whatsapp",
                    "email",
                    "sms"
                  ]
                },
                "sender": {
                  "type": "object",
                  "properties": {
                    "providerId": {
                      "type": "string"
                    },
                    "address": {
                      "type": "string"
                    },
                    "role": {
                      "type": "string",
                      "enum": [
                        "user",
                        "contact",
                        "system"
                      ]
                    },
                    "displayName": {
                      "type": "string"
                    },
                    "metadata": {
                      "type": "object",
                      "additionalProperties": {}
                    }
                  },
                  "required": [
                    "providerId",
                    "address",
                    "role"
                  ]
                },
                "recipient": {
                  "type": "object",
                  "properties": {
                    "providerId": {
                      "type": "string"
                    },
                    "address": {
                      "type": "string"
                    },
                    "role": {
                      "type": "string",
                      "enum": [
                        "user",
                        "contact",
                        "system"
                      ]
                    },
                    "displayName": {
                      "type": "string"
                    },
                    "metadata": {
                      "type": "object",
                      "additionalProperties": {}
                    }
                  },
                  "required": [
                    "providerId",
                    "address",
                    "role"
                  ]
                },
                "attachments": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "string"
                      },
                      "type": {
                        "type": "string",
                        "enum": [
                          "image",
                          "video",
                          "audio",
                          "file"
                        ]
                      },
                      "url": {
                        "type": "string"
                      },
                      "unsignedUrl": {
                        "type": "string"
                      },
                      "metadata": {
                        "type": "object",
                        "additionalProperties": {}
                      },
                      "mediaProcessing": {
                        "type": "object",
                        "properties": {
                          "textRepresentation": {
                            "type": "object",
                            "properties": {
                              "status": {
                                "type": "string",
                                "enum": [
                                  "pending",
                                  "processing",
                                  "completed",
                                  "failed"
                                ]
                              },
                              "content": {
                                "type": "string"
                              },
                              "processedAt": {
                                "type": "string"
                              },
                              "errorMessage": {
                                "type": "string"
                              }
                            },
                            "required": [
                              "status"
                            ]
                          },
                          "summary": {
                            "type": "object",
                            "properties": {
                              "status": {
                                "type": "string",
                                "enum": [
                                  "pending",
                                  "processing",
                                  "completed",
                                  "failed"
                                ]
                              },
                              "content": {
                                "type": "string"
                              },
                              "processedAt": {
                                "type": "string"
                              },
                              "errorMessage": {
                                "type": "string"
                              }
                            },
                            "required": [
                              "status"
                            ]
                          }
                        }
                      },
                      "isCacheable": {
                        "type": "boolean"
                      }
                    },
                    "required": [
                      "id",
                      "type",
                      "url"
                    ]
                  }
                },
                "createdAt": {
                  "type": "string"
                },
                "updatedAt": {
                  "type": "string"
                },
                "metadata": {
                  "type": "object",
                  "additionalProperties": {}
                },
                "errors": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "code": {
                        "type": "number"
                      },
                      "title": {
                        "type": "string"
                      },
                      "message": {
                        "type": "string"
                      },
                      "href": {
                        "type": "string"
                      },
                      "provider": {
                        "type": "string"
                      }
                    },
                    "required": [
                      "title"
                    ]
                  }
                },
                "customFields": {
                  "type": "object",
                  "additionalProperties": {}
                },
                "mediaProcessing": {
                  "type": "object",
                  "properties": {
                    "textRepresentation": {
                      "type": "object",
                      "properties": {
                        "status": {
                          "type": "string",
                          "enum": [
                            "pending",
                            "processing",
                            "completed",
                            "failed"
                          ]
                        },
                        "content": {
                          "type": "string"
                        },
                        "processedAt": {
                          "type": "string"
                        },
                        "errorMessage": {
                          "type": "string"
                        }
                      },
                      "required": [
                        "status"
                      ]
                    },
                    "summary": {
                      "type": "object",
                      "properties": {
                        "status": {
                          "type": "string",
                          "enum": [
                            "pending",
                            "processing",
                            "completed",
                            "failed"
                          ]
                        },
                        "content": {
                          "type": "string"
                        },
                        "processedAt": {
                          "type": "string"
                        },
                        "errorMessage": {
                          "type": "string"
                        }
                      },
                      "required": [
                        "status"
                      ]
                    }
                  }
                }
              },
              "required": [
                "id",
                "tenantId",
                "conversationId",
                "funnelConversationId",
                "providerId",
                "content",
                "status",
                "direction",
                "channel",
                "sender",
                "createdAt",
                "updatedAt"
              ]
            }
          },
          "required": [
            "eventId",
            "eventType",
            "tenantId",
            "funnelConversationId",
            "resourceId",
            "occurredAt",
            "resourceType",
            "action",
            "resource"
          ]
        },
        {
          "type": "object",
          "properties": {
            "eventId": {
              "type": "string",
              "minLength": 1
            },
            "eventType": {
              "type": "string",
              "enum": [
                "communications.message.deleted"
              ]
            },
            "tenantId": {
              "type": "string",
              "minLength": 1
            },
            "funnelId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "funnelConversationId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "messagingConversationId": {
              "type": "string",
              "minLength": 1
            },
            "resourceId": {
              "type": "string",
              "minLength": 1
            },
            "occurredAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
            },
            "resourceType": {
              "type": "string",
              "enum": [
                "Message"
              ]
            },
            "action": {
              "type": "string",
              "enum": [
                "deleted"
              ]
            },
            "resource": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "string"
                },
                "tenantId": {
                  "type": "string"
                },
                "conversationId": {
                  "type": "string"
                },
                "funnelConversationId": {
                  "type": "integer",
                  "exclusiveMinimum": true,
                  "maximum": 9007199254740991
                },
                "sessionId": {
                  "type": "number"
                },
                "providerId": {
                  "type": "string"
                },
                "contactId": {
                  "type": "number"
                },
                "userId": {
                  "type": "string"
                },
                "content": {
                  "type": "string"
                },
                "status": {
                  "type": "string",
                  "enum": [
                    "pending",
                    "sent",
                    "failed",
                    "delivered",
                    "read",
                    "deleted",
                    "warning"
                  ]
                },
                "direction": {
                  "type": "string",
                  "enum": [
                    "inbound",
                    "outbound"
                  ]
                },
                "channel": {
                  "type": "string",
                  "enum": [
                    "whatsapp",
                    "email",
                    "sms"
                  ]
                },
                "sender": {
                  "type": "object",
                  "properties": {
                    "providerId": {
                      "type": "string"
                    },
                    "address": {
                      "type": "string"
                    },
                    "role": {
                      "type": "string",
                      "enum": [
                        "user",
                        "contact",
                        "system"
                      ]
                    },
                    "displayName": {
                      "type": "string"
                    },
                    "metadata": {
                      "type": "object",
                      "additionalProperties": {}
                    }
                  },
                  "required": [
                    "providerId",
                    "address",
                    "role"
                  ]
                },
                "recipient": {
                  "type": "object",
                  "properties": {
                    "providerId": {
                      "type": "string"
                    },
                    "address": {
                      "type": "string"
                    },
                    "role": {
                      "type": "string",
                      "enum": [
                        "user",
                        "contact",
                        "system"
                      ]
                    },
                    "displayName": {
                      "type": "string"
                    },
                    "metadata": {
                      "type": "object",
                      "additionalProperties": {}
                    }
                  },
                  "required": [
                    "providerId",
                    "address",
                    "role"
                  ]
                },
                "attachments": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "string"
                      },
                      "type": {
                        "type": "string",
                        "enum": [
                          "image",
                          "video",
                          "audio",
                          "file"
                        ]
                      },
                      "url": {
                        "type": "string"
                      },
                      "unsignedUrl": {
                        "type": "string"
                      },
                      "metadata": {
                        "type": "object",
                        "additionalProperties": {}
                      },
                      "mediaProcessing": {
                        "type": "object",
                        "properties": {
                          "textRepresentation": {
                            "type": "object",
                            "properties": {
                              "status": {
                                "type": "string",
                                "enum": [
                                  "pending",
                                  "processing",
                                  "completed",
                                  "failed"
                                ]
                              },
                              "content": {
                                "type": "string"
                              },
                              "processedAt": {
                                "type": "string"
                              },
                              "errorMessage": {
                                "type": "string"
                              }
                            },
                            "required": [
                              "status"
                            ]
                          },
                          "summary": {
                            "type": "object",
                            "properties": {
                              "status": {
                                "type": "string",
                                "enum": [
                                  "pending",
                                  "processing",
                                  "completed",
                                  "failed"
                                ]
                              },
                              "content": {
                                "type": "string"
                              },
                              "processedAt": {
                                "type": "string"
                              },
                              "errorMessage": {
                                "type": "string"
                              }
                            },
                            "required": [
                              "status"
                            ]
                          }
                        }
                      },
                      "isCacheable": {
                        "type": "boolean"
                      }
                    },
                    "required": [
                      "id",
                      "type",
                      "url"
                    ]
                  }
                },
                "createdAt": {
                  "type": "string"
                },
                "updatedAt": {
                  "type": "string"
                },
                "metadata": {
                  "type": "object",
                  "additionalProperties": {}
                },
                "errors": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "code": {
                        "type": "number"
                      },
                      "title": {
                        "type": "string"
                      },
                      "message": {
                        "type": "string"
                      },
                      "href": {
                        "type": "string"
                      },
                      "provider": {
                        "type": "string"
                      }
                    },
                    "required": [
                      "title"
                    ]
                  }
                },
                "customFields": {
                  "type": "object",
                  "additionalProperties": {}
                },
                "mediaProcessing": {
                  "type": "object",
                  "properties": {
                    "textRepresentation": {
                      "type": "object",
                      "properties": {
                        "status": {
                          "type": "string",
                          "enum": [
                            "pending",
                            "processing",
                            "completed",
                            "failed"
                          ]
                        },
                        "content": {
                          "type": "string"
                        },
                        "processedAt": {
                          "type": "string"
                        },
                        "errorMessage": {
                          "type": "string"
                        }
                      },
                      "required": [
                        "status"
                      ]
                    },
                    "summary": {
                      "type": "object",
                      "properties": {
                        "status": {
                          "type": "string",
                          "enum": [
                            "pending",
                            "processing",
                            "completed",
                            "failed"
                          ]
                        },
                        "content": {
                          "type": "string"
                        },
                        "processedAt": {
                          "type": "string"
                        },
                        "errorMessage": {
                          "type": "string"
                        }
                      },
                      "required": [
                        "status"
                      ]
                    }
                  }
                }
              },
              "required": [
                "id",
                "tenantId",
                "conversationId",
                "funnelConversationId",
                "providerId",
                "content",
                "status",
                "direction",
                "channel",
                "sender",
                "createdAt",
                "updatedAt"
              ]
            }
          },
          "required": [
            "eventId",
            "eventType",
            "tenantId",
            "funnelConversationId",
            "resourceId",
            "occurredAt",
            "resourceType",
            "action"
          ]
        }
      ]
    },
    {
      "oneOf": [
        {
          "type": "object",
          "properties": {
            "eventId": {
              "type": "string",
              "minLength": 1
            },
            "eventType": {
              "type": "string",
              "enum": [
                "communications.conversation.created"
              ]
            },
            "tenantId": {
              "type": "string",
              "minLength": 1
            },
            "funnelId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "funnelConversationId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "messagingConversationId": {
              "type": "string",
              "minLength": 1
            },
            "resourceId": {
              "type": "string",
              "minLength": 1
            },
            "occurredAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
            },
            "resourceType": {
              "type": "string",
              "enum": [
                "Conversation"
              ]
            },
            "document": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "string"
                },
                "modelType": {
                  "type": "string",
                  "enum": [
                    "Conversation"
                  ]
                },
                "tenantId": {
                  "type": "string"
                },
                "createdAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "updatedAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "archivedAt": {
                  "nullable": true,
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "eventSequence": {
                  "type": "number"
                },
                "eventTimestamp": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "userId": {
                  "nullable": true,
                  "type": "number"
                },
                "channelSessions": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "number"
                      },
                      "tenantId": {
                        "type": "string"
                      },
                      "funnelConversationId": {
                        "type": "number"
                      },
                      "funnelAddressId": {
                        "type": "number"
                      },
                      "contactAddressId": {
                        "type": "number"
                      },
                      "archivedAt": {
                        "nullable": true,
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "startTime": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "endTime": {
                        "nullable": true,
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "channelType": {
                        "type": "string",
                        "enum": [
                          "WHATSAPP",
                          "PHONE",
                          "EMAIL"
                        ]
                      },
                      "messagingConversationId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "createdAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      }
                    },
                    "required": [
                      "id",
                      "tenantId",
                      "funnelConversationId",
                      "funnelAddressId",
                      "contactAddressId",
                      "startTime",
                      "channelType",
                      "createdAt",
                      "updatedAt"
                    ]
                  }
                },
                "contacts": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "number"
                      },
                      "tenantId": {
                        "type": "string"
                      },
                      "providerId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "providerName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "nationalId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "firstName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "lastName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "email": {
                        "nullable": true,
                        "type": "string"
                      },
                      "phone": {
                        "nullable": true,
                        "type": "string"
                      },
                      "userId": {
                        "nullable": true,
                        "type": "number"
                      },
                      "contactCompanyId": {
                        "nullable": true,
                        "type": "number"
                      },
                      "companyPosition": {
                        "nullable": true,
                        "type": "string"
                      },
                      "metadata": {},
                      "createdAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "customFields": {
                        "type": "object",
                        "additionalProperties": {}
                      },
                      "addresses": {
                        "type": "array",
                        "items": {
                          "type": "object",
                          "properties": {
                            "id": {
                              "type": "number"
                            },
                            "tenantId": {
                              "type": "string"
                            },
                            "contactId": {
                              "type": "number"
                            },
                            "channelType": {
                              "type": "string",
                              "enum": [
                                "WHATSAPP",
                                "PHONE",
                                "EMAIL"
                              ]
                            },
                            "address": {
                              "type": "string"
                            },
                            "createdAt": {
                              "type": "string",
                              "format": "date-time",
                              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                            },
                            "updatedAt": {
                              "type": "string",
                              "format": "date-time",
                              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                            }
                          },
                          "required": [
                            "id",
                            "tenantId",
                            "contactId",
                            "channelType",
                            "address",
                            "createdAt",
                            "updatedAt"
                          ]
                        }
                      }
                    },
                    "required": [
                      "id",
                      "tenantId",
                      "metadata",
                      "createdAt",
                      "updatedAt"
                    ]
                  }
                },
                "customFields": {
                  "type": "object",
                  "additionalProperties": {}
                },
                "contactId": {
                  "type": "string"
                },
                "propertyId": {
                  "type": "string"
                },
                "funnelId": {
                  "type": "string"
                },
                "funnelStatusId": {
                  "type": "string"
                },
                "statusDateFields": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "statusId": {
                        "type": "string"
                      },
                      "transitionDate": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      }
                    },
                    "required": [
                      "statusId",
                      "transitionDate"
                    ]
                  }
                },
                "lastInteractionAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "lastInteraction": {
                  "type": "object",
                  "properties": {
                    "id": {
                      "type": "string"
                    },
                    "modelType": {
                      "type": "string",
                      "enum": [
                        "Message",
                        "Call"
                      ]
                    },
                    "snippet": {
                      "type": "string"
                    },
                    "status": {
                      "anyOf": [
                        {
                          "type": "string",
                          "enum": [
                            "pending",
                            "sent",
                            "failed",
                            "delivered",
                            "read",
                            "deleted",
                            "warning"
                          ]
                        },
                        {
                          "type": "string",
                          "enum": [
                            "queued",
                            "initiated",
                            "ringing",
                            "in-progress",
                            "completed",
                            "busy",
                            "failed",
                            "no-answer",
                            "canceled",
                            "unknown"
                          ]
                        }
                      ]
                    },
                    "direction": {
                      "type": "string",
                      "enum": [
                        "incoming",
                        "outgoing"
                      ]
                    }
                  },
                  "required": [
                    "id",
                    "modelType"
                  ]
                }
              },
              "required": [
                "id",
                "modelType",
                "tenantId",
                "createdAt",
                "updatedAt"
              ]
            },
            "action": {
              "type": "string",
              "enum": [
                "created"
              ]
            },
            "resource": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "number"
                },
                "tenantId": {
                  "type": "string"
                },
                "contactId": {
                  "type": "number"
                },
                "userId": {
                  "nullable": true,
                  "type": "number"
                },
                "propertyId": {
                  "nullable": true,
                  "type": "number"
                },
                "funnelId": {
                  "type": "number"
                },
                "funnelStatusId": {
                  "nullable": true,
                  "type": "number"
                },
                "archivedAt": {
                  "nullable": true,
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "createdAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "updatedAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "channelSessions": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "number"
                      },
                      "tenantId": {
                        "type": "string"
                      },
                      "funnelConversationId": {
                        "type": "number"
                      },
                      "funnelAddressId": {
                        "type": "number"
                      },
                      "contactAddressId": {
                        "type": "number"
                      },
                      "archivedAt": {
                        "nullable": true,
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "startTime": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "endTime": {
                        "nullable": true,
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "channelType": {
                        "type": "string",
                        "enum": [
                          "WHATSAPP",
                          "PHONE",
                          "EMAIL"
                        ]
                      },
                      "messagingConversationId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "createdAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      }
                    },
                    "required": [
                      "id",
                      "tenantId",
                      "funnelConversationId",
                      "funnelAddressId",
                      "contactAddressId",
                      "startTime",
                      "channelType",
                      "createdAt",
                      "updatedAt"
                    ]
                  }
                },
                "contacts": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "number"
                      },
                      "tenantId": {
                        "type": "string"
                      },
                      "providerId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "providerName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "nationalId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "firstName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "lastName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "email": {
                        "nullable": true,
                        "type": "string"
                      },
                      "phone": {
                        "nullable": true,
                        "type": "string"
                      },
                      "userId": {
                        "nullable": true,
                        "type": "number"
                      },
                      "contactCompanyId": {
                        "nullable": true,
                        "type": "number"
                      },
                      "companyPosition": {
                        "nullable": true,
                        "type": "string"
                      },
                      "metadata": {},
                      "createdAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "customFields": {
                        "type": "object",
                        "additionalProperties": {}
                      },
                      "addresses": {
                        "type": "array",
                        "items": {
                          "type": "object",
                          "properties": {
                            "id": {
                              "type": "number"
                            },
                            "tenantId": {
                              "type": "string"
                            },
                            "contactId": {
                              "type": "number"
                            },
                            "channelType": {
                              "type": "string",
                              "enum": [
                                "WHATSAPP",
                                "PHONE",
                                "EMAIL"
                              ]
                            },
                            "address": {
                              "type": "string"
                            },
                            "createdAt": {
                              "type": "string",
                              "format": "date-time",
                              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                            },
                            "updatedAt": {
                              "type": "string",
                              "format": "date-time",
                              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                            }
                          },
                          "required": [
                            "id",
                            "tenantId",
                            "contactId",
                            "channelType",
                            "address",
                            "createdAt",
                            "updatedAt"
                          ]
                        }
                      }
                    },
                    "required": [
                      "id",
                      "tenantId",
                      "metadata",
                      "createdAt",
                      "updatedAt"
                    ]
                  }
                },
                "customFields": {
                  "type": "object",
                  "additionalProperties": {}
                }
              },
              "required": [
                "id",
                "tenantId",
                "contactId",
                "funnelId",
                "createdAt",
                "updatedAt"
              ]
            }
          },
          "required": [
            "eventId",
            "eventType",
            "tenantId",
            "funnelId",
            "funnelConversationId",
            "resourceId",
            "occurredAt",
            "resourceType",
            "action",
            "resource"
          ]
        },
        {
          "type": "object",
          "properties": {
            "eventId": {
              "type": "string",
              "minLength": 1
            },
            "eventType": {
              "type": "string",
              "enum": [
                "communications.conversation.updated"
              ]
            },
            "tenantId": {
              "type": "string",
              "minLength": 1
            },
            "funnelId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "funnelConversationId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "messagingConversationId": {
              "type": "string",
              "minLength": 1
            },
            "resourceId": {
              "type": "string",
              "minLength": 1
            },
            "occurredAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
            },
            "resourceType": {
              "type": "string",
              "enum": [
                "Conversation"
              ]
            },
            "document": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "string"
                },
                "modelType": {
                  "type": "string",
                  "enum": [
                    "Conversation"
                  ]
                },
                "tenantId": {
                  "type": "string"
                },
                "createdAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "updatedAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "archivedAt": {
                  "nullable": true,
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "eventSequence": {
                  "type": "number"
                },
                "eventTimestamp": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "userId": {
                  "nullable": true,
                  "type": "number"
                },
                "channelSessions": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "number"
                      },
                      "tenantId": {
                        "type": "string"
                      },
                      "funnelConversationId": {
                        "type": "number"
                      },
                      "funnelAddressId": {
                        "type": "number"
                      },
                      "contactAddressId": {
                        "type": "number"
                      },
                      "archivedAt": {
                        "nullable": true,
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "startTime": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "endTime": {
                        "nullable": true,
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "channelType": {
                        "type": "string",
                        "enum": [
                          "WHATSAPP",
                          "PHONE",
                          "EMAIL"
                        ]
                      },
                      "messagingConversationId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "createdAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      }
                    },
                    "required": [
                      "id",
                      "tenantId",
                      "funnelConversationId",
                      "funnelAddressId",
                      "contactAddressId",
                      "startTime",
                      "channelType",
                      "createdAt",
                      "updatedAt"
                    ]
                  }
                },
                "contacts": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "number"
                      },
                      "tenantId": {
                        "type": "string"
                      },
                      "providerId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "providerName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "nationalId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "firstName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "lastName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "email": {
                        "nullable": true,
                        "type": "string"
                      },
                      "phone": {
                        "nullable": true,
                        "type": "string"
                      },
                      "userId": {
                        "nullable": true,
                        "type": "number"
                      },
                      "contactCompanyId": {
                        "nullable": true,
                        "type": "number"
                      },
                      "companyPosition": {
                        "nullable": true,
                        "type": "string"
                      },
                      "metadata": {},
                      "createdAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "customFields": {
                        "type": "object",
                        "additionalProperties": {}
                      },
                      "addresses": {
                        "type": "array",
                        "items": {
                          "type": "object",
                          "properties": {
                            "id": {
                              "type": "number"
                            },
                            "tenantId": {
                              "type": "string"
                            },
                            "contactId": {
                              "type": "number"
                            },
                            "channelType": {
                              "type": "string",
                              "enum": [
                                "WHATSAPP",
                                "PHONE",
                                "EMAIL"
                              ]
                            },
                            "address": {
                              "type": "string"
                            },
                            "createdAt": {
                              "type": "string",
                              "format": "date-time",
                              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                            },
                            "updatedAt": {
                              "type": "string",
                              "format": "date-time",
                              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                            }
                          },
                          "required": [
                            "id",
                            "tenantId",
                            "contactId",
                            "channelType",
                            "address",
                            "createdAt",
                            "updatedAt"
                          ]
                        }
                      }
                    },
                    "required": [
                      "id",
                      "tenantId",
                      "metadata",
                      "createdAt",
                      "updatedAt"
                    ]
                  }
                },
                "customFields": {
                  "type": "object",
                  "additionalProperties": {}
                },
                "contactId": {
                  "type": "string"
                },
                "propertyId": {
                  "type": "string"
                },
                "funnelId": {
                  "type": "string"
                },
                "funnelStatusId": {
                  "type": "string"
                },
                "statusDateFields": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "statusId": {
                        "type": "string"
                      },
                      "transitionDate": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      }
                    },
                    "required": [
                      "statusId",
                      "transitionDate"
                    ]
                  }
                },
                "lastInteractionAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "lastInteraction": {
                  "type": "object",
                  "properties": {
                    "id": {
                      "type": "string"
                    },
                    "modelType": {
                      "type": "string",
                      "enum": [
                        "Message",
                        "Call"
                      ]
                    },
                    "snippet": {
                      "type": "string"
                    },
                    "status": {
                      "anyOf": [
                        {
                          "type": "string",
                          "enum": [
                            "pending",
                            "sent",
                            "failed",
                            "delivered",
                            "read",
                            "deleted",
                            "warning"
                          ]
                        },
                        {
                          "type": "string",
                          "enum": [
                            "queued",
                            "initiated",
                            "ringing",
                            "in-progress",
                            "completed",
                            "busy",
                            "failed",
                            "no-answer",
                            "canceled",
                            "unknown"
                          ]
                        }
                      ]
                    },
                    "direction": {
                      "type": "string",
                      "enum": [
                        "incoming",
                        "outgoing"
                      ]
                    }
                  },
                  "required": [
                    "id",
                    "modelType"
                  ]
                }
              },
              "required": [
                "id",
                "modelType",
                "tenantId",
                "createdAt",
                "updatedAt"
              ]
            },
            "action": {
              "type": "string",
              "enum": [
                "updated"
              ]
            },
            "resource": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "number"
                },
                "tenantId": {
                  "type": "string"
                },
                "contactId": {
                  "type": "number"
                },
                "userId": {
                  "nullable": true,
                  "type": "number"
                },
                "propertyId": {
                  "nullable": true,
                  "type": "number"
                },
                "funnelId": {
                  "type": "number"
                },
                "funnelStatusId": {
                  "nullable": true,
                  "type": "number"
                },
                "archivedAt": {
                  "nullable": true,
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "createdAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "updatedAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "channelSessions": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "number"
                      },
                      "tenantId": {
                        "type": "string"
                      },
                      "funnelConversationId": {
                        "type": "number"
                      },
                      "funnelAddressId": {
                        "type": "number"
                      },
                      "contactAddressId": {
                        "type": "number"
                      },
                      "archivedAt": {
                        "nullable": true,
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "startTime": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "endTime": {
                        "nullable": true,
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "channelType": {
                        "type": "string",
                        "enum": [
                          "WHATSAPP",
                          "PHONE",
                          "EMAIL"
                        ]
                      },
                      "messagingConversationId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "createdAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      }
                    },
                    "required": [
                      "id",
                      "tenantId",
                      "funnelConversationId",
                      "funnelAddressId",
                      "contactAddressId",
                      "startTime",
                      "channelType",
                      "createdAt",
                      "updatedAt"
                    ]
                  }
                },
                "contacts": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "number"
                      },
                      "tenantId": {
                        "type": "string"
                      },
                      "providerId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "providerName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "nationalId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "firstName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "lastName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "email": {
                        "nullable": true,
                        "type": "string"
                      },
                      "phone": {
                        "nullable": true,
                        "type": "string"
                      },
                      "userId": {
                        "nullable": true,
                        "type": "number"
                      },
                      "contactCompanyId": {
                        "nullable": true,
                        "type": "number"
                      },
                      "companyPosition": {
                        "nullable": true,
                        "type": "string"
                      },
                      "metadata": {},
                      "createdAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "customFields": {
                        "type": "object",
                        "additionalProperties": {}
                      },
                      "addresses": {
                        "type": "array",
                        "items": {
                          "type": "object",
                          "properties": {
                            "id": {
                              "type": "number"
                            },
                            "tenantId": {
                              "type": "string"
                            },
                            "contactId": {
                              "type": "number"
                            },
                            "channelType": {
                              "type": "string",
                              "enum": [
                                "WHATSAPP",
                                "PHONE",
                                "EMAIL"
                              ]
                            },
                            "address": {
                              "type": "string"
                            },
                            "createdAt": {
                              "type": "string",
                              "format": "date-time",
                              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                            },
                            "updatedAt": {
                              "type": "string",
                              "format": "date-time",
                              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                            }
                          },
                          "required": [
                            "id",
                            "tenantId",
                            "contactId",
                            "channelType",
                            "address",
                            "createdAt",
                            "updatedAt"
                          ]
                        }
                      }
                    },
                    "required": [
                      "id",
                      "tenantId",
                      "metadata",
                      "createdAt",
                      "updatedAt"
                    ]
                  }
                },
                "customFields": {
                  "type": "object",
                  "additionalProperties": {}
                }
              },
              "required": [
                "id",
                "tenantId",
                "contactId",
                "funnelId",
                "createdAt",
                "updatedAt"
              ]
            }
          },
          "required": [
            "eventId",
            "eventType",
            "tenantId",
            "funnelId",
            "funnelConversationId",
            "resourceId",
            "occurredAt",
            "resourceType",
            "action",
            "resource"
          ]
        },
        {
          "type": "object",
          "properties": {
            "eventId": {
              "type": "string",
              "minLength": 1
            },
            "eventType": {
              "type": "string",
              "enum": [
                "communications.conversation.deleted"
              ]
            },
            "tenantId": {
              "type": "string",
              "minLength": 1
            },
            "funnelId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "funnelConversationId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "messagingConversationId": {
              "type": "string",
              "minLength": 1
            },
            "resourceId": {
              "type": "string",
              "minLength": 1
            },
            "occurredAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
            },
            "resourceType": {
              "type": "string",
              "enum": [
                "Conversation"
              ]
            },
            "document": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "string"
                },
                "modelType": {
                  "type": "string",
                  "enum": [
                    "Conversation"
                  ]
                },
                "tenantId": {
                  "type": "string"
                },
                "createdAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "updatedAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "archivedAt": {
                  "nullable": true,
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "eventSequence": {
                  "type": "number"
                },
                "eventTimestamp": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "userId": {
                  "nullable": true,
                  "type": "number"
                },
                "channelSessions": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "number"
                      },
                      "tenantId": {
                        "type": "string"
                      },
                      "funnelConversationId": {
                        "type": "number"
                      },
                      "funnelAddressId": {
                        "type": "number"
                      },
                      "contactAddressId": {
                        "type": "number"
                      },
                      "archivedAt": {
                        "nullable": true,
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "startTime": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "endTime": {
                        "nullable": true,
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "channelType": {
                        "type": "string",
                        "enum": [
                          "WHATSAPP",
                          "PHONE",
                          "EMAIL"
                        ]
                      },
                      "messagingConversationId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "createdAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      }
                    },
                    "required": [
                      "id",
                      "tenantId",
                      "funnelConversationId",
                      "funnelAddressId",
                      "contactAddressId",
                      "startTime",
                      "channelType",
                      "createdAt",
                      "updatedAt"
                    ]
                  }
                },
                "contacts": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "number"
                      },
                      "tenantId": {
                        "type": "string"
                      },
                      "providerId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "providerName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "nationalId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "firstName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "lastName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "email": {
                        "nullable": true,
                        "type": "string"
                      },
                      "phone": {
                        "nullable": true,
                        "type": "string"
                      },
                      "userId": {
                        "nullable": true,
                        "type": "number"
                      },
                      "contactCompanyId": {
                        "nullable": true,
                        "type": "number"
                      },
                      "companyPosition": {
                        "nullable": true,
                        "type": "string"
                      },
                      "metadata": {},
                      "createdAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "customFields": {
                        "type": "object",
                        "additionalProperties": {}
                      },
                      "addresses": {
                        "type": "array",
                        "items": {
                          "type": "object",
                          "properties": {
                            "id": {
                              "type": "number"
                            },
                            "tenantId": {
                              "type": "string"
                            },
                            "contactId": {
                              "type": "number"
                            },
                            "channelType": {
                              "type": "string",
                              "enum": [
                                "WHATSAPP",
                                "PHONE",
                                "EMAIL"
                              ]
                            },
                            "address": {
                              "type": "string"
                            },
                            "createdAt": {
                              "type": "string",
                              "format": "date-time",
                              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                            },
                            "updatedAt": {
                              "type": "string",
                              "format": "date-time",
                              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                            }
                          },
                          "required": [
                            "id",
                            "tenantId",
                            "contactId",
                            "channelType",
                            "address",
                            "createdAt",
                            "updatedAt"
                          ]
                        }
                      }
                    },
                    "required": [
                      "id",
                      "tenantId",
                      "metadata",
                      "createdAt",
                      "updatedAt"
                    ]
                  }
                },
                "customFields": {
                  "type": "object",
                  "additionalProperties": {}
                },
                "contactId": {
                  "type": "string"
                },
                "propertyId": {
                  "type": "string"
                },
                "funnelId": {
                  "type": "string"
                },
                "funnelStatusId": {
                  "type": "string"
                },
                "statusDateFields": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "statusId": {
                        "type": "string"
                      },
                      "transitionDate": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      }
                    },
                    "required": [
                      "statusId",
                      "transitionDate"
                    ]
                  }
                },
                "lastInteractionAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "lastInteraction": {
                  "type": "object",
                  "properties": {
                    "id": {
                      "type": "string"
                    },
                    "modelType": {
                      "type": "string",
                      "enum": [
                        "Message",
                        "Call"
                      ]
                    },
                    "snippet": {
                      "type": "string"
                    },
                    "status": {
                      "anyOf": [
                        {
                          "type": "string",
                          "enum": [
                            "pending",
                            "sent",
                            "failed",
                            "delivered",
                            "read",
                            "deleted",
                            "warning"
                          ]
                        },
                        {
                          "type": "string",
                          "enum": [
                            "queued",
                            "initiated",
                            "ringing",
                            "in-progress",
                            "completed",
                            "busy",
                            "failed",
                            "no-answer",
                            "canceled",
                            "unknown"
                          ]
                        }
                      ]
                    },
                    "direction": {
                      "type": "string",
                      "enum": [
                        "incoming",
                        "outgoing"
                      ]
                    }
                  },
                  "required": [
                    "id",
                    "modelType"
                  ]
                }
              },
              "required": [
                "id",
                "modelType",
                "tenantId",
                "createdAt",
                "updatedAt"
              ]
            },
            "action": {
              "type": "string",
              "enum": [
                "deleted"
              ]
            },
            "resource": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "number"
                },
                "tenantId": {
                  "type": "string"
                },
                "contactId": {
                  "type": "number"
                },
                "userId": {
                  "nullable": true,
                  "type": "number"
                },
                "propertyId": {
                  "nullable": true,
                  "type": "number"
                },
                "funnelId": {
                  "type": "number"
                },
                "funnelStatusId": {
                  "nullable": true,
                  "type": "number"
                },
                "archivedAt": {
                  "nullable": true,
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "createdAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "updatedAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "channelSessions": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "number"
                      },
                      "tenantId": {
                        "type": "string"
                      },
                      "funnelConversationId": {
                        "type": "number"
                      },
                      "funnelAddressId": {
                        "type": "number"
                      },
                      "contactAddressId": {
                        "type": "number"
                      },
                      "archivedAt": {
                        "nullable": true,
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "startTime": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "endTime": {
                        "nullable": true,
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "channelType": {
                        "type": "string",
                        "enum": [
                          "WHATSAPP",
                          "PHONE",
                          "EMAIL"
                        ]
                      },
                      "messagingConversationId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "createdAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      }
                    },
                    "required": [
                      "id",
                      "tenantId",
                      "funnelConversationId",
                      "funnelAddressId",
                      "contactAddressId",
                      "startTime",
                      "channelType",
                      "createdAt",
                      "updatedAt"
                    ]
                  }
                },
                "contacts": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "number"
                      },
                      "tenantId": {
                        "type": "string"
                      },
                      "providerId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "providerName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "nationalId": {
                        "nullable": true,
                        "type": "string"
                      },
                      "firstName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "lastName": {
                        "nullable": true,
                        "type": "string"
                      },
                      "email": {
                        "nullable": true,
                        "type": "string"
                      },
                      "phone": {
                        "nullable": true,
                        "type": "string"
                      },
                      "userId": {
                        "nullable": true,
                        "type": "number"
                      },
                      "contactCompanyId": {
                        "nullable": true,
                        "type": "number"
                      },
                      "companyPosition": {
                        "nullable": true,
                        "type": "string"
                      },
                      "metadata": {},
                      "createdAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "updatedAt": {
                        "type": "string",
                        "format": "date-time",
                        "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                      },
                      "customFields": {
                        "type": "object",
                        "additionalProperties": {}
                      },
                      "addresses": {
                        "type": "array",
                        "items": {
                          "type": "object",
                          "properties": {
                            "id": {
                              "type": "number"
                            },
                            "tenantId": {
                              "type": "string"
                            },
                            "contactId": {
                              "type": "number"
                            },
                            "channelType": {
                              "type": "string",
                              "enum": [
                                "WHATSAPP",
                                "PHONE",
                                "EMAIL"
                              ]
                            },
                            "address": {
                              "type": "string"
                            },
                            "createdAt": {
                              "type": "string",
                              "format": "date-time",
                              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                            },
                            "updatedAt": {
                              "type": "string",
                              "format": "date-time",
                              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                            }
                          },
                          "required": [
                            "id",
                            "tenantId",
                            "contactId",
                            "channelType",
                            "address",
                            "createdAt",
                            "updatedAt"
                          ]
                        }
                      }
                    },
                    "required": [
                      "id",
                      "tenantId",
                      "metadata",
                      "createdAt",
                      "updatedAt"
                    ]
                  }
                },
                "customFields": {
                  "type": "object",
                  "additionalProperties": {}
                }
              },
              "required": [
                "id",
                "tenantId",
                "contactId",
                "funnelId",
                "createdAt",
                "updatedAt"
              ]
            }
          },
          "required": [
            "eventId",
            "eventType",
            "tenantId",
            "funnelId",
            "funnelConversationId",
            "resourceId",
            "occurredAt",
            "resourceType",
            "action"
          ]
        }
      ]
    },
    {
      "type": "object",
      "properties": {
        "eventId": {
          "type": "string",
          "minLength": 1
        },
        "eventType": {
          "type": "string",
          "enum": [
            "communications.status-history.created"
          ]
        },
        "tenantId": {
          "type": "string",
          "minLength": 1
        },
        "funnelId": {
          "type": "integer",
          "exclusiveMinimum": true,
          "maximum": 9007199254740991
        },
        "funnelConversationId": {
          "type": "integer",
          "exclusiveMinimum": true,
          "maximum": 9007199254740991
        },
        "messagingConversationId": {
          "type": "string",
          "minLength": 1
        },
        "resourceId": {
          "type": "string",
          "minLength": 1
        },
        "occurredAt": {
          "type": "string",
          "format": "date-time",
          "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
        },
        "resourceType": {
          "type": "string",
          "enum": [
            "StatusHistory"
          ]
        },
        "action": {
          "type": "string",
          "enum": [
            "created"
          ]
        },
        "resource": {
          "type": "object",
          "properties": {
            "id": {
              "type": "number"
            },
            "tenantId": {
              "type": "string"
            },
            "funnelConversationId": {
              "type": "number"
            },
            "contactId": {
              "nullable": true,
              "type": "number"
            },
            "fromStatusId": {
              "nullable": true,
              "type": "number"
            },
            "toStatusId": {
              "nullable": true,
              "type": "number"
            },
            "changedAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
            },
            "changedById": {
              "nullable": true,
              "type": "string"
            },
            "changedBySource": {
              "type": "string",
              "enum": [
                "USER",
                "SYSTEM",
                "AI"
              ]
            }
          },
          "required": [
            "id",
            "tenantId",
            "funnelConversationId",
            "changedAt",
            "changedBySource"
          ]
        }
      },
      "required": [
        "eventId",
        "eventType",
        "tenantId",
        "funnelId",
        "funnelConversationId",
        "resourceId",
        "occurredAt",
        "resourceType",
        "action",
        "resource"
      ]
    },
    {
      "oneOf": [
        {
          "type": "object",
          "properties": {
            "eventId": {
              "type": "string",
              "minLength": 1
            },
            "eventType": {
              "type": "string",
              "enum": [
                "communications.channel-session.created"
              ]
            },
            "tenantId": {
              "type": "string",
              "minLength": 1
            },
            "funnelId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "funnelConversationId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "messagingConversationId": {
              "type": "string",
              "minLength": 1
            },
            "resourceId": {
              "type": "string",
              "minLength": 1
            },
            "occurredAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
            },
            "resourceType": {
              "type": "string",
              "enum": [
                "ChannelSession"
              ]
            },
            "action": {
              "type": "string",
              "enum": [
                "created"
              ]
            },
            "resource": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "number"
                },
                "tenantId": {
                  "type": "string"
                },
                "funnelConversationId": {
                  "type": "number"
                },
                "funnelAddressId": {
                  "type": "number"
                },
                "contactAddressId": {
                  "type": "number"
                },
                "archivedAt": {
                  "nullable": true,
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "startTime": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "endTime": {
                  "nullable": true,
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "channelType": {
                  "type": "string",
                  "enum": [
                    "WHATSAPP",
                    "PHONE",
                    "EMAIL"
                  ]
                },
                "messagingConversationId": {
                  "nullable": true,
                  "type": "string"
                },
                "createdAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "updatedAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                }
              },
              "required": [
                "id",
                "tenantId",
                "funnelConversationId",
                "funnelAddressId",
                "contactAddressId",
                "startTime",
                "channelType",
                "createdAt",
                "updatedAt"
              ]
            }
          },
          "required": [
            "eventId",
            "eventType",
            "tenantId",
            "funnelId",
            "funnelConversationId",
            "resourceId",
            "occurredAt",
            "resourceType",
            "action",
            "resource"
          ]
        },
        {
          "type": "object",
          "properties": {
            "eventId": {
              "type": "string",
              "minLength": 1
            },
            "eventType": {
              "type": "string",
              "enum": [
                "communications.channel-session.updated"
              ]
            },
            "tenantId": {
              "type": "string",
              "minLength": 1
            },
            "funnelId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "funnelConversationId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "messagingConversationId": {
              "type": "string",
              "minLength": 1
            },
            "resourceId": {
              "type": "string",
              "minLength": 1
            },
            "occurredAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
            },
            "resourceType": {
              "type": "string",
              "enum": [
                "ChannelSession"
              ]
            },
            "action": {
              "type": "string",
              "enum": [
                "updated"
              ]
            },
            "resource": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "number"
                },
                "tenantId": {
                  "type": "string"
                },
                "funnelConversationId": {
                  "type": "number"
                },
                "funnelAddressId": {
                  "type": "number"
                },
                "contactAddressId": {
                  "type": "number"
                },
                "archivedAt": {
                  "nullable": true,
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "startTime": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "endTime": {
                  "nullable": true,
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "channelType": {
                  "type": "string",
                  "enum": [
                    "WHATSAPP",
                    "PHONE",
                    "EMAIL"
                  ]
                },
                "messagingConversationId": {
                  "nullable": true,
                  "type": "string"
                },
                "createdAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "updatedAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                }
              },
              "required": [
                "id",
                "tenantId",
                "funnelConversationId",
                "funnelAddressId",
                "contactAddressId",
                "startTime",
                "channelType",
                "createdAt",
                "updatedAt"
              ]
            }
          },
          "required": [
            "eventId",
            "eventType",
            "tenantId",
            "funnelId",
            "funnelConversationId",
            "resourceId",
            "occurredAt",
            "resourceType",
            "action",
            "resource"
          ]
        },
        {
          "type": "object",
          "properties": {
            "eventId": {
              "type": "string",
              "minLength": 1
            },
            "eventType": {
              "type": "string",
              "enum": [
                "communications.channel-session.deleted"
              ]
            },
            "tenantId": {
              "type": "string",
              "minLength": 1
            },
            "funnelId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "funnelConversationId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "messagingConversationId": {
              "type": "string",
              "minLength": 1
            },
            "resourceId": {
              "type": "string",
              "minLength": 1
            },
            "occurredAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
            },
            "resourceType": {
              "type": "string",
              "enum": [
                "ChannelSession"
              ]
            },
            "action": {
              "type": "string",
              "enum": [
                "deleted"
              ]
            },
            "resource": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "number"
                },
                "tenantId": {
                  "type": "string"
                },
                "funnelConversationId": {
                  "type": "number"
                },
                "funnelAddressId": {
                  "type": "number"
                },
                "contactAddressId": {
                  "type": "number"
                },
                "archivedAt": {
                  "nullable": true,
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "startTime": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "endTime": {
                  "nullable": true,
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "channelType": {
                  "type": "string",
                  "enum": [
                    "WHATSAPP",
                    "PHONE",
                    "EMAIL"
                  ]
                },
                "messagingConversationId": {
                  "nullable": true,
                  "type": "string"
                },
                "createdAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "updatedAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                }
              },
              "required": [
                "id",
                "tenantId",
                "funnelConversationId",
                "funnelAddressId",
                "contactAddressId",
                "startTime",
                "channelType",
                "createdAt",
                "updatedAt"
              ]
            }
          },
          "required": [
            "eventId",
            "eventType",
            "tenantId",
            "funnelId",
            "funnelConversationId",
            "resourceId",
            "occurredAt",
            "resourceType",
            "action"
          ]
        }
      ]
    },
    {
      "oneOf": [
        {
          "type": "object",
          "properties": {
            "eventId": {
              "type": "string",
              "minLength": 1
            },
            "eventType": {
              "type": "string",
              "enum": [
                "communications.call.created"
              ]
            },
            "tenantId": {
              "type": "string",
              "minLength": 1
            },
            "funnelId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "funnelConversationId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "messagingConversationId": {
              "type": "string",
              "minLength": 1
            },
            "resourceId": {
              "type": "string",
              "minLength": 1
            },
            "occurredAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
            },
            "resourceType": {
              "type": "string",
              "enum": [
                "Call"
              ]
            },
            "action": {
              "type": "string",
              "enum": [
                "created"
              ]
            },
            "resource": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "number"
                },
                "tenantId": {
                  "type": "string"
                },
                "providerId": {
                  "type": "string"
                },
                "providerName": {
                  "type": "string"
                },
                "funnelConversationId": {
                  "type": "integer",
                  "exclusiveMinimum": true,
                  "maximum": 9007199254740991
                },
                "sessionId": {
                  "type": "number"
                },
                "userId": {
                  "nullable": true,
                  "type": "number"
                },
                "contactId": {
                  "type": "number"
                },
                "analysisConfigId": {
                  "type": "number"
                },
                "teamId": {
                  "nullable": true,
                  "type": "number"
                },
                "from": {
                  "type": "string"
                },
                "to": {
                  "type": "string"
                },
                "redirectedTo": {
                  "nullable": true,
                  "type": "string"
                },
                "duration": {
                  "type": "number"
                },
                "direction": {
                  "type": "string"
                },
                "status": {
                  "type": "string",
                  "enum": [
                    "queued",
                    "initiated",
                    "ringing",
                    "in-progress",
                    "completed",
                    "busy",
                    "failed",
                    "no-answer",
                    "canceled",
                    "unknown"
                  ]
                },
                "startTime": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "metadata": {
                  "type": "object",
                  "additionalProperties": {}
                },
                "customData": {
                  "type": "object",
                  "additionalProperties": {}
                },
                "category": {
                  "type": "string"
                },
                "createdAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "updatedAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "recordingUrl": {
                  "nullable": true,
                  "type": "string"
                },
                "analysis": {
                  "type": "object",
                  "properties": {
                    "id": {
                      "type": "number"
                    },
                    "status": {
                      "type": "string"
                    },
                    "analysisValues": {
                      "type": "array",
                      "items": {
                        "type": "object",
                        "properties": {
                          "id": {
                            "type": "number"
                          },
                          "tenantId": {
                            "type": "string"
                          },
                          "type": {
                            "type": "string"
                          },
                          "value": {
                            "type": "string"
                          },
                          "evidence": {
                            "nullable": true,
                            "type": "string"
                          },
                          "createdAt": {
                            "type": "string",
                            "format": "date-time",
                            "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                          },
                          "updatedAt": {
                            "type": "string",
                            "format": "date-time",
                            "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                          },
                          "configKey": {
                            "type": "string"
                          },
                          "description": {
                            "type": "string"
                          },
                          "scoreMinCriteria": {
                            "type": "string"
                          },
                          "scoreMaxCriteria": {
                            "type": "string"
                          },
                          "scoreMinValue": {
                            "type": "number"
                          },
                          "scoreMaxValue": {
                            "type": "number"
                          },
                          "goalPriority": {
                            "type": "number"
                          },
                          "extractionAnswerType": {
                            "type": "string"
                          },
                          "extractionExampleValue": {
                            "type": "string"
                          }
                        },
                        "required": [
                          "id",
                          "tenantId",
                          "type",
                          "value",
                          "evidence",
                          "createdAt",
                          "updatedAt"
                        ]
                      }
                    },
                    "createdAt": {
                      "type": "string",
                      "format": "date-time",
                      "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                    }
                  },
                  "required": [
                    "id",
                    "status",
                    "analysisValues",
                    "createdAt"
                  ]
                },
                "transcription": {
                  "type": "object",
                  "properties": {
                    "text": {
                      "nullable": true,
                      "type": "string"
                    }
                  },
                  "required": [
                    "text"
                  ]
                }
              },
              "required": [
                "id",
                "tenantId",
                "providerId",
                "providerName",
                "funnelConversationId",
                "userId",
                "contactId",
                "from",
                "to",
                "duration",
                "direction",
                "status",
                "startTime",
                "customData",
                "createdAt",
                "updatedAt"
              ]
            }
          },
          "required": [
            "eventId",
            "eventType",
            "tenantId",
            "funnelConversationId",
            "resourceId",
            "occurredAt",
            "resourceType",
            "action",
            "resource"
          ]
        },
        {
          "type": "object",
          "properties": {
            "eventId": {
              "type": "string",
              "minLength": 1
            },
            "eventType": {
              "type": "string",
              "enum": [
                "communications.call.updated"
              ]
            },
            "tenantId": {
              "type": "string",
              "minLength": 1
            },
            "funnelId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "funnelConversationId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "messagingConversationId": {
              "type": "string",
              "minLength": 1
            },
            "resourceId": {
              "type": "string",
              "minLength": 1
            },
            "occurredAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
            },
            "resourceType": {
              "type": "string",
              "enum": [
                "Call"
              ]
            },
            "action": {
              "type": "string",
              "enum": [
                "updated"
              ]
            },
            "resource": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "number"
                },
                "tenantId": {
                  "type": "string"
                },
                "providerId": {
                  "type": "string"
                },
                "providerName": {
                  "type": "string"
                },
                "funnelConversationId": {
                  "type": "integer",
                  "exclusiveMinimum": true,
                  "maximum": 9007199254740991
                },
                "sessionId": {
                  "type": "number"
                },
                "userId": {
                  "nullable": true,
                  "type": "number"
                },
                "contactId": {
                  "type": "number"
                },
                "analysisConfigId": {
                  "type": "number"
                },
                "teamId": {
                  "nullable": true,
                  "type": "number"
                },
                "from": {
                  "type": "string"
                },
                "to": {
                  "type": "string"
                },
                "redirectedTo": {
                  "nullable": true,
                  "type": "string"
                },
                "duration": {
                  "type": "number"
                },
                "direction": {
                  "type": "string"
                },
                "status": {
                  "type": "string",
                  "enum": [
                    "queued",
                    "initiated",
                    "ringing",
                    "in-progress",
                    "completed",
                    "busy",
                    "failed",
                    "no-answer",
                    "canceled",
                    "unknown"
                  ]
                },
                "startTime": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "metadata": {
                  "type": "object",
                  "additionalProperties": {}
                },
                "customData": {
                  "type": "object",
                  "additionalProperties": {}
                },
                "category": {
                  "type": "string"
                },
                "createdAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "updatedAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "recordingUrl": {
                  "nullable": true,
                  "type": "string"
                },
                "analysis": {
                  "type": "object",
                  "properties": {
                    "id": {
                      "type": "number"
                    },
                    "status": {
                      "type": "string"
                    },
                    "analysisValues": {
                      "type": "array",
                      "items": {
                        "type": "object",
                        "properties": {
                          "id": {
                            "type": "number"
                          },
                          "tenantId": {
                            "type": "string"
                          },
                          "type": {
                            "type": "string"
                          },
                          "value": {
                            "type": "string"
                          },
                          "evidence": {
                            "nullable": true,
                            "type": "string"
                          },
                          "createdAt": {
                            "type": "string",
                            "format": "date-time",
                            "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                          },
                          "updatedAt": {
                            "type": "string",
                            "format": "date-time",
                            "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                          },
                          "configKey": {
                            "type": "string"
                          },
                          "description": {
                            "type": "string"
                          },
                          "scoreMinCriteria": {
                            "type": "string"
                          },
                          "scoreMaxCriteria": {
                            "type": "string"
                          },
                          "scoreMinValue": {
                            "type": "number"
                          },
                          "scoreMaxValue": {
                            "type": "number"
                          },
                          "goalPriority": {
                            "type": "number"
                          },
                          "extractionAnswerType": {
                            "type": "string"
                          },
                          "extractionExampleValue": {
                            "type": "string"
                          }
                        },
                        "required": [
                          "id",
                          "tenantId",
                          "type",
                          "value",
                          "evidence",
                          "createdAt",
                          "updatedAt"
                        ]
                      }
                    },
                    "createdAt": {
                      "type": "string",
                      "format": "date-time",
                      "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                    }
                  },
                  "required": [
                    "id",
                    "status",
                    "analysisValues",
                    "createdAt"
                  ]
                },
                "transcription": {
                  "type": "object",
                  "properties": {
                    "text": {
                      "nullable": true,
                      "type": "string"
                    }
                  },
                  "required": [
                    "text"
                  ]
                }
              },
              "required": [
                "id",
                "tenantId",
                "providerId",
                "providerName",
                "funnelConversationId",
                "userId",
                "contactId",
                "from",
                "to",
                "duration",
                "direction",
                "status",
                "startTime",
                "customData",
                "createdAt",
                "updatedAt"
              ]
            }
          },
          "required": [
            "eventId",
            "eventType",
            "tenantId",
            "funnelConversationId",
            "resourceId",
            "occurredAt",
            "resourceType",
            "action",
            "resource"
          ]
        },
        {
          "type": "object",
          "properties": {
            "eventId": {
              "type": "string",
              "minLength": 1
            },
            "eventType": {
              "type": "string",
              "enum": [
                "communications.call.completed"
              ]
            },
            "tenantId": {
              "type": "string",
              "minLength": 1
            },
            "funnelId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "funnelConversationId": {
              "type": "integer",
              "exclusiveMinimum": true,
              "maximum": 9007199254740991
            },
            "messagingConversationId": {
              "type": "string",
              "minLength": 1
            },
            "resourceId": {
              "type": "string",
              "minLength": 1
            },
            "occurredAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
            },
            "resourceType": {
              "type": "string",
              "enum": [
                "Call"
              ]
            },
            "action": {
              "type": "string",
              "enum": [
                "completed"
              ]
            },
            "resource": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "number"
                },
                "tenantId": {
                  "type": "string"
                },
                "providerId": {
                  "type": "string"
                },
                "providerName": {
                  "type": "string"
                },
                "funnelConversationId": {
                  "type": "integer",
                  "exclusiveMinimum": true,
                  "maximum": 9007199254740991
                },
                "sessionId": {
                  "type": "number"
                },
                "userId": {
                  "nullable": true,
                  "type": "number"
                },
                "contactId": {
                  "type": "number"
                },
                "analysisConfigId": {
                  "type": "number"
                },
                "teamId": {
                  "nullable": true,
                  "type": "number"
                },
                "from": {
                  "type": "string"
                },
                "to": {
                  "type": "string"
                },
                "redirectedTo": {
                  "nullable": true,
                  "type": "string"
                },
                "duration": {
                  "type": "number"
                },
                "direction": {
                  "type": "string"
                },
                "status": {
                  "type": "string",
                  "enum": [
                    "queued",
                    "initiated",
                    "ringing",
                    "in-progress",
                    "completed",
                    "busy",
                    "failed",
                    "no-answer",
                    "canceled",
                    "unknown"
                  ]
                },
                "startTime": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "metadata": {
                  "type": "object",
                  "additionalProperties": {}
                },
                "customData": {
                  "type": "object",
                  "additionalProperties": {}
                },
                "category": {
                  "type": "string"
                },
                "createdAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "updatedAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                },
                "recordingUrl": {
                  "nullable": true,
                  "type": "string"
                },
                "analysis": {
                  "type": "object",
                  "properties": {
                    "id": {
                      "type": "number"
                    },
                    "status": {
                      "type": "string"
                    },
                    "analysisValues": {
                      "type": "array",
                      "items": {
                        "type": "object",
                        "properties": {
                          "id": {
                            "type": "number"
                          },
                          "tenantId": {
                            "type": "string"
                          },
                          "type": {
                            "type": "string"
                          },
                          "value": {
                            "type": "string"
                          },
                          "evidence": {
                            "nullable": true,
                            "type": "string"
                          },
                          "createdAt": {
                            "type": "string",
                            "format": "date-time",
                            "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                          },
                          "updatedAt": {
                            "type": "string",
                            "format": "date-time",
                            "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                          },
                          "configKey": {
                            "type": "string"
                          },
                          "description": {
                            "type": "string"
                          },
                          "scoreMinCriteria": {
                            "type": "string"
                          },
                          "scoreMaxCriteria": {
                            "type": "string"
                          },
                          "scoreMinValue": {
                            "type": "number"
                          },
                          "scoreMaxValue": {
                            "type": "number"
                          },
                          "goalPriority": {
                            "type": "number"
                          },
                          "extractionAnswerType": {
                            "type": "string"
                          },
                          "extractionExampleValue": {
                            "type": "string"
                          }
                        },
                        "required": [
                          "id",
                          "tenantId",
                          "type",
                          "value",
                          "evidence",
                          "createdAt",
                          "updatedAt"
                        ]
                      }
                    },
                    "createdAt": {
                      "type": "string",
                      "format": "date-time",
                      "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?(?:Z))$"
                    }
                  },
                  "required": [
                    "id",
                    "status",
                    "analysisValues",
                    "createdAt"
                  ]
                },
                "transcription": {
                  "type": "object",
                  "properties": {
                    "text": {
                      "nullable": true,
                      "type": "string"
                    }
                  },
                  "required": [
                    "text"
                  ]
                }
              },
              "required": [
                "id",
                "tenantId",
                "providerId",
                "providerName",
                "funnelConversationId",
                "userId",
                "contactId",
                "from",
                "to",
                "duration",
                "direction",
                "status",
                "startTime",
                "customData",
                "createdAt",
                "updatedAt"
              ]
            }
          },
          "required": [
            "eventId",
            "eventType",
            "tenantId",
            "funnelConversationId",
            "resourceId",
            "occurredAt",
            "resourceType",
            "action",
            "resource"
          ]
        }
      ]
    }
  ],
  "x-browser-runtime-schema": true,
  "x-browser-union-model": true
} satisfies JSONSchema.JSONSchema;
